var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"technical-details"}},[_c('card',{attrs:{"icon":"laptop-medical","headline":_vm.$t('visitors.checks.headline'),"description":_vm.$t('visitors.checks.description')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }